import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useVoteListToggle } from 'common/Prose/Toolbar/hooks/useVoteListToggle'
import { ShortcutAwareTooltip } from 'common/Prose/utils/ShortcutAwareTooltip'
import { SingleMenuDropdownItem } from '../SingleMenuDropdown/SingleMenuDropdownItem'
import { ListVote } from 'almanac-ui/icons/16'
import { observer } from 'mobx-react-lite'

export const VoteListButton = observer(({ withLabel = false }: { withLabel?: boolean }) => {
  const view = useEditorView()
  const { active, handleClick, disabled } = useVoteListToggle(view)

  return (
    <ShortcutAwareTooltip label="Vote list">
      <SingleMenuDropdownItem
        icon={<ListVote />}
        label={withLabel ? 'Vote list' : ''}
        active={active}
        disabled={disabled}
        handleClick={handleClick}
      />
    </ShortcutAwareTooltip>
  )
})
